export class RecuperarPassClavePeticion{
    public codCliente:string;
    public codTpoPortal:string;
    public docEmpresa:string;
    public claveUsuario: string;
    public correoUsuario: string;
    public movilUsuario: string;
    public countryMovilUsuario: string;
    public tipoEnvio: string = '';
}